<div class="no-margin-wrapper">
  <div class="download-dialog-container">
    <div class="header-row">
      Prepare selected layers for download
    </div>
    <div class="horizontal-separator">

    </div>
    <div class="content-area-row">
<div class="layers-list-col">
@for (layer of data.layerList; track layer) {
  @if (layer.layer.name !== 'Water') {
    <div class="layer-element">
      <img [src]="getThumbImage(layer.layer.name)" alt="layer-tile">
      <span>
        {{ layer.layer.name }}
      </span>
      <mat-checkbox (change)="layerSelected($event, layer)">
      </mat-checkbox>
    </div>
  }
}

</div>
</div>

</div>
<div class="button-row">
  <button mat-raised-button (click)="closeDialog()">{{ "actions.cancel" | translate }}</button>
  <button mat-raised-button color="primary" class="frmg-primary-button" (click)="goToDownloads()"
    [disabled]="!selectedLayers.length && isLoading">{{ "actions.request" | translate }}
  </button>
</div>
</div>